"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.map.js");

require("core-js/modules/es6.regexp.replace.js");

require("core-js/modules/es6.regexp.split.js");

require("core-js/modules/es6.function.name.js");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _validator = _interopRequireDefault(require("validator"));

var _uniq = _interopRequireDefault(require("lodash-es/uniq"));

var _reactReduxForm = require("react-redux-form");

var _Input = require("../../shared/Input");

var _Tabs = _interopRequireDefault(require("../../shared/Tabs"));

var _RecentLocations = _interopRequireDefault(require("../customAddresses/RecentLocations"));

var _SearchResults = _interopRequireDefault(require("../customAddresses/SearchResults"));

var _fetchCities = require("@evdy/web-redux/dist/actions/dash/fetchCities");

var _leftChev = _interopRequireDefault(require("../../../images/left-chev.svg"));

var _dec, _class;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

require('../../../sass/components/shared/elements/universalModal/CustomAddressModalBody.css');

var searchIcon = require('../../../images/blue-search-bar-icon@2x.png');

var isRequired = function isRequired(value) {
  return !_validator.default.isEmpty('' + value);
};

var NewCustomAddressModalBody = (_dec = (0, _reactRedux.connect)(function (_ref) {
  var eventAddress = _ref.forms.eventAddress,
      fetchedCities = _ref.dash.fetchedCities;
  return {
    eventAddress: eventAddress,
    fetchedCities: fetchedCities
  };
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(NewCustomAddressModalBody, _React$Component);

  var _super = _createSuper(NewCustomAddressModalBody);

  function NewCustomAddressModalBody(props) {
    var _this;

    _classCallCheck(this, NewCustomAddressModalBody);

    _this = _super.call(this, props);

    _this.renderRecentLocations = function () {
      return /*#__PURE__*/_react.default.createElement(_RecentLocations.default, {
        userData: _this.props.user,
        recentLocationsLimit: 15,
        handleUseLocation: _this.handleUseLocation,
        analyticsPrefix: _this.props.analyticsPrefix
      });
    };

    _this.renderSearchResults = function () {
      return /*#__PURE__*/_react.default.createElement(_SearchResults.default, {
        searchResults: _this.props.funeralHomeArray,
        isFetching: _this.props.isFetchingGoogleHomes,
        paginationState: _this.state,
        handleUseLocation: _this.handleUseLocation,
        handlePrevResultsClick: _this.handlePrevResultsClick,
        handleNextResultsClick: _this.handleNextResultsClick,
        analyticsPrefix: _this.props.analyticsPrefix
      });
    };

    _this.state = {
      addressModalIndex: 0,
      currentSearchPage: 0,
      searchResultsLimit: 5,
      recentLocationsLimit: 5,
      totalSearchResults: 0,
      totalSearchPages: 0,
      currentPageLowerBound: 0,
      currentPageUpperBound: 0,
      cityArray: []
    };
    _this.handleAddressModalTabChange = _this.handleAddressModalTabChange.bind(_assertThisInitialized(_this));
    _this.getTabClass = _this.getTabClass.bind(_assertThisInitialized(_this));
    _this.clearAddressSearch = _this.clearAddressSearch.bind(_assertThisInitialized(_this));
    _this.handleUseLocation = _this.handleUseLocation.bind(_assertThisInitialized(_this));
    _this.handleLocationInputChange = _this.handleLocationInputChange.bind(_assertThisInitialized(_this));
    _this.handleLocationSelect = _this.handleLocationSelect.bind(_assertThisInitialized(_this));
    _this.renderRecentLocations = _this.renderRecentLocations.bind(_assertThisInitialized(_this));
    _this.renderSearchResults = _this.renderSearchResults.bind(_assertThisInitialized(_this));
    _this.handlePrevResultsClick = _this.handlePrevResultsClick.bind(_assertThisInitialized(_this));
    _this.handleNextResultsClick = _this.handleNextResultsClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(NewCustomAddressModalBody, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // Recalculate and reset search state when search text is changed
      if (this.props.funeralHomeArray && nextProps.funeralHomeArray && this.props.eventAddress.locationSearchText !== nextProps.eventAddress.locationSearchText || this.props.funeralHomeArray.length !== nextProps.funeralHomeArray.length) {
        var searchResultsLimit = this.state.searchResultsLimit;
        var totalSearchResults = !nextProps.eventAddress.locationSearchText ? 0 : nextProps.funeralHomeArray.length;
        var totalSearchPages = Math.ceil(totalSearchResults / searchResultsLimit);
        var currentPageLowerBound = 0;
        var currentPageUpperBound = searchResultsLimit;
        var currentSearchPage = 0;
        this.setState({
          totalSearchResults: totalSearchResults,
          totalSearchPages: totalSearchPages,
          currentPageLowerBound: currentPageLowerBound,
          currentPageUpperBound: currentPageUpperBound,
          currentSearchPage: currentSearchPage
        });
      } //for searching cities:


      var cities = this.props.fetchedCities.cities;
      var nextCities = nextProps.fetchedCities.cities;
      var cityArray = [];

      if (cities && nextCities && cities !== nextCities) {
        cityArray = (0, _uniq.default)(nextCities.data.map(function (foundCity) {
          return foundCity.description.replace(/USA$/, 'US');
        }));
        this.setState({
          cityArray: cityArray
        });
      }
    }
  }, {
    key: "handleAddressModalTabChange",
    value: function handleAddressModalTabChange(value) {
      this.setState({
        addressModalIndex: value
      });
    }
  }, {
    key: "getTabClass",
    value: function getTabClass(tabIndex) {
      return this.state.addressModalIndex === tabIndex ? 'custom-address-tab custom-address-tab-active' : 'custom-address-tab custom-address-tab-inactive';
    }
  }, {
    key: "handlePrevResultsClick",
    value: function handlePrevResultsClick() {
      var _this$state = this.state,
          currentSearchPage = _this$state.currentSearchPage,
          currentPageLowerBound = _this$state.currentPageLowerBound,
          currentPageUpperBound = _this$state.currentPageUpperBound,
          searchResultsLimit = _this$state.searchResultsLimit;
      this.setState({
        currentSearchPage: currentSearchPage - 1,
        currentPageLowerBound: currentPageLowerBound - searchResultsLimit,
        currentPageUpperBound: currentPageUpperBound - searchResultsLimit
      });
    }
  }, {
    key: "handleNextResultsClick",
    value: function handleNextResultsClick() {
      var _this$state2 = this.state,
          currentSearchPage = _this$state2.currentSearchPage,
          currentPageLowerBound = _this$state2.currentPageLowerBound,
          currentPageUpperBound = _this$state2.currentPageUpperBound,
          searchResultsLimit = _this$state2.searchResultsLimit;
      this.setState({
        currentSearchPage: currentSearchPage + 1,
        currentPageLowerBound: currentPageLowerBound + searchResultsLimit,
        currentPageUpperBound: currentPageUpperBound + searchResultsLimit
      });
    }
  }, {
    key: "clearAddressSearch",
    value: function clearAddressSearch() {
      // Clear search input then reset search values
      this.props.clearLocationSearch();
      this.setState({
        currentSearchPage: 0,
        currentPageLowerBound: 0,
        currentPageUpperBound: this.state.searchResultsLimit
      });
    }
  }, {
    key: "handleUseLocation",
    value: function handleUseLocation(location) {
      var _this2 = this;

      return function () {
        _this2.props.handleTypeaheadSelection()(location);

        _this2.props.handleAddRecentLocation(location);
      };
    }
  }, {
    key: "handleLocationInputChange",
    value: function handleLocationInputChange() {
      var typeaheadValue = this.props.eventAddress.customAddress.city;
      this.props.dispatch((0, _fetchCities.fetchCities)(typeaheadValue));
    }
  }, {
    key: "handleLocationSelect",
    value: function handleLocationSelect() {
      var _this3 = this;

      return function (e) {
        var dispatch = _this3.props.dispatch;
        var splitLoc = e.split(',');
        dispatch(_reactReduxForm.actions.change('forms.eventAddress.customAddress.city', splitLoc[0]));
        dispatch(_reactReduxForm.actions.change('forms.eventAddress.customAddress.state', splitLoc[1]));
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this,
          _eventAddress$customA;

      var _this$props = this.props,
          eventAddress = _this$props.eventAddress,
          handleTypeaheadChange = _this$props.handleTypeaheadChange,
          closeCustomAddressModal = _this$props.closeCustomAddressModal;
      var cityArray = this.state.cityArray;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-container custom-address-modal"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body modal-content"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _leftChev.default,
        className: "close-location-modal-button",
        onClick: closeCustomAddressModal
      }), /*#__PURE__*/_react.default.createElement(_reactReduxForm.Form, {
        model: 'forms.eventAddress',
        className: "inputs-container"
      }, /*#__PURE__*/_react.default.createElement(_Tabs.default, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "search-address-wrapper",
        label: "Search"
      }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
        model: '.locationSearchText',
        onChange: function onChange(e) {
          return handleTypeaheadChange(e.target.value);
        },
        placeholder: "Search for location",
        customClass: "location-modal-search-input",
        pre: searchIcon
      }), eventAddress.locationSearchText && /*#__PURE__*/_react.default.createElement("div", {
        className: "clear-search-icon",
        onClick: this.clearAddressSearch
      }), eventAddress.locationSearchText ? this.renderSearchResults() : this.renderRecentLocations()), /*#__PURE__*/_react.default.createElement("div", {
        label: "Custom Address",
        customClass: "custom-address-tab-content"
      }, /*#__PURE__*/_react.default.createElement(_Input.InputGroup, {
        full: true,
        model: '.customAddress.name',
        labelText: 'Location name *',
        validators: {
          isRequired: isRequired
        },
        messages: {
          isRequired: 'Name is required'
        }
      }), /*#__PURE__*/_react.default.createElement(_Input.InputGroup, {
        full: true,
        model: '.customAddress.address',
        labelText: 'Address *',
        validators: {
          isRequired: isRequired
        },
        messages: {
          isRequired: 'Address is required'
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "custom-address-row"
      }, /*#__PURE__*/_react.default.createElement(_Input.Typeahead, {
        model: ".customAddress.city",
        modelBase: "forms.eventAddress",
        labelText: "City",
        data: cityArray,
        limit: 5,
        customClass: "custom-address-city-input",
        onChange: this.handleLocationInputChange,
        onSelect: function onSelect(e) {
          return _this4.handleLocationSelect()(e);
        }
      }), /*#__PURE__*/_react.default.createElement(_Input.InputGroup, {
        model: '.customAddress.state',
        labelText: 'State',
        customClass: "custom-address-state-input"
      }), /*#__PURE__*/_react.default.createElement(_Input.InputGroup, {
        model: '.customAddress.zip',
        labelText: 'Zip code',
        customClass: "custom-address-zip-input"
      })), /*#__PURE__*/_react.default.createElement("button", {
        disabled: !(eventAddress !== null && eventAddress !== void 0 && (_eventAddress$customA = eventAddress.customAddress) !== null && _eventAddress$customA !== void 0 && _eventAddress$customA.name),
        className: "custom-address-save-button",
        onClick: this.props.saveCustomAddress
      }, "Use Location"))))));
    }
  }]);

  return NewCustomAddressModalBody;
}(_react.default.Component)) || _class);
exports.default = NewCustomAddressModalBody;